var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#4C75A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7944 28.9986H30.5096C29.2674 28.9986 28.8931 28.0389 26.6663 25.9135C24.7202 24.1244 23.8983 23.902 23.406 23.902C22.7251 23.902 22.5395 24.0805 22.5395 24.9743V27.7917C22.5395 28.5538 22.2804 29 20.1932 29C18.1683 28.8702 16.2048 28.2835 14.4642 27.2881C12.7237 26.2926 11.2559 24.917 10.182 23.2745C7.63274 20.2465 5.85849 16.6934 5 12.8972C5 12.4276 5.18713 12.002 6.12563 12.002H9.40754C10.251 12.002 10.5548 12.3604 10.8858 13.1883C12.4793 17.6616 15.1984 21.5527 16.3024 21.5527C16.7256 21.5527 16.9098 21.3742 16.9098 20.3678V15.76C16.7702 13.6579 15.6 13.4807 15.6 12.7201C15.6148 12.5194 15.711 12.3321 15.8682 12.1981C16.0255 12.064 16.2313 11.9936 16.442 12.002H21.601C22.3063 12.002 22.5395 12.337 22.5395 13.1416V19.3614C22.5395 20.0328 22.8417 20.2552 23.0548 20.2552C23.478 20.2552 23.8033 20.0328 24.5791 19.2941C26.2415 17.3591 27.6002 15.2038 28.6124 12.8958C28.7155 12.6184 28.9112 12.3809 29.1694 12.2197C29.4275 12.0586 29.734 11.9825 30.0418 12.0034H33.3251C34.3097 12.0034 34.5184 12.4729 34.3097 13.143C33.1152 15.6945 31.6376 18.1166 29.9021 20.3678C29.548 20.8827 29.407 21.1504 29.9021 21.7546C30.2275 22.2241 31.379 23.1413 32.152 24.0132C33.2776 25.0841 34.2118 26.3226 34.9186 27.6792C35.2007 28.5524 34.7314 28.9986 33.7944 28.9986Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkIcon);
export default __webpack_public_path__ + "static/media/vk_icon.e9d227e96c1969898adb483b0936d710.svg";
export { ForwardRef as ReactComponent };